import api from '../api/axios';

export interface Stock {
  id?: number;
  product: number;
  warehouse: number;
  quantity: number;
  minQuantity?: number;
  maxQuantity?: number;
  reorderPoint?: number;
  lastUpdated?: string;
  location?: string;
}

const StockService = {
  getAll: (params?: any) => api.get('/stocks', { params }),
  getOne: (id: number) => api.get(`/stocks/${id}`, { params: { populate: '*' } }),
  create: (data: Stock) => api.post('/stocks', { data }),
  update: (id: number, data: Partial<Stock>) => api.put(`/stocks/${id}`, { data }),
  delete: (id: number) => api.delete(`/stocks/${id}`),
};

export default StockService;
